/** @jsx jsx */

import { ComponentProps } from 'react';

import { css, jsx } from '@emotion/core';

import MultiSelect from '../MultiSelect';

const styleContainer = css`
  height: fit-content;
  max-height: 325px;
  overflow-y: auto;
`;

type MultiSelectItems = ComponentProps<typeof MultiSelect>['items'];

type Props = {
  items: MultiSelectItems;
  itemsType?: string;
  maxSelectedItems?: number;
  onChange: (selectedItems: MultiSelectItems) => void;
  selectedItems: MultiSelectItems;
  placeholder: string;
  emptyDropdownMessage?: string;
};

export default function MultiSelectDropdown({
  items,
  itemsType = 'items',
  maxSelectedItems,
  onChange,
  selectedItems,
  placeholder,
  emptyDropdownMessage,
}: Props) {
  return (
    <MultiSelect
      disabledItemTooltip={`You can select a maximum of ${maxSelectedItems} ${itemsType}`}
      emptyMessage={emptyDropdownMessage}
      extraStyleMenuItemsContainer={styleContainer}
      items={items}
      maxSelectedItems={maxSelectedItems}
      onChange={onChange}
      selectedItems={selectedItems}
    >
      {selectedItems.length > 0
        ? selectedItems.map(x => x?.label).join(', ')
        : placeholder}
    </MultiSelect>
  );
}
